var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c("w-data-table", {
        attrs: {
          "empty-label": _vm.$ct("common.empty-list"),
          columns: _vm.cols,
          items: _vm.ledgers,
          "selected-items": _vm.selectedItems,
          compare: _vm.compareFunction,
        },
        on: {
          "item-clicked": function ($event) {
            return _vm.onClick($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }